export const calculateSumOfSize = (acceptedFiles, removedFileId) => acceptedFiles
  .filter((file) => file.fileId !== removedFileId)
  .reduce((totalSize, file) => totalSize + file.size, 0);

export const calculateDocsTotalSize = (docs) => docs
  .reduce((totalSize, doc) => totalSize + doc.size, 0);

export const getEmptyStatusMessage = () => ({
  message: '',
  type: '',
});

export const getRejectedFileStatus = (file, maxFileSize, maxSizeLabel) => {
  if (file.size > maxFileSize) {
    return {
      message: 'sizeExceedsError',
      type: 'error',
      fileSize: maxSizeLabel,
    };
  }

  if (file.size === 0) {
    return { message: 'sizeError', type: 'error' };
  }

  return { message: 'extensionError', type: 'error' };
};

export const getAcceptedFileSum = (acceptedFiles, currentSum) => acceptedFiles
  .reduce((sum, file) => sum + file.size, currentSum);

export const isBatchWithinSize = (
  acceptedFiles,
  fileSum,
  maxBatchSize
) => (acceptedFiles.length > 0 ? fileSum < maxBatchSize : false);

export const createFormDataWithFields = (formDataProps) => {
  const formData = new FormData();
  Object.keys(formDataProps).forEach((key) => {
    formData.append(key, formDataProps[key]);
  });
  return formData;
};

export const createDeleteBody = (formDataProps) => JSON.stringify({
  processId: formDataProps.processId,
  consumerId: formDataProps.consumerId,
});

export const createSubmitBody = (formDataProps, documentId) => JSON.stringify({
  processId: formDataProps.processId,
  consumerId: formDataProps.consumerId,
  documentId,
  idxFields: formDataProps,
});

export const getUploadResponseOutcome = (response) => {
  if (response?.status?.statusCode === '50200') {
    return 'success';
  }
  if (response?.status?.statusCode === '50640') {
    return 'imageQualityError';
  }
  if (response?.errors !== undefined) {
    return 'loadApiError';
  }
  return 'uploadApiError';
};

export const getDeleteResponseOutcome = (response) => {
  if (response?.status?.statusCode === '70200') {
    return 'success';
  }
  if (response?.errors !== undefined) {
    return 'loadApiError';
  }
  return 'deleteApiError';
};

export const getSubmitResponseOutcome = (response) => {
  if (response?.status?.statusCode === '60200') {
    return 'success';
  }
  if (response?.errors !== undefined) {
    return 'loadApiError';
  }
  return 'submitNetworkErrorLabel';
};

export const validateSubmitState = ({ acceptedDocs, isSubmitDisabled, isDeleting }) => {
  if (acceptedDocs.length <= 0) {
    return 'noFilesError';
  }
  if (isSubmitDisabled) {
    return 'requiredError';
  }
  const hasUploadInProgress = acceptedDocs.some((doc) => doc.progress !== null);
  if (hasUploadInProgress && !isDeleting) {
    return 'waitingForUpload';
  }
  if (isDeleting) {
    return 'waitingForDelete';
  }
  return null;
};

export const markDocAsDeleting = (docs, fileId) => docs.map(
  (doc) => (doc.fileId === fileId ? { ...doc, progress: 0 } : doc)
);

export const createUploadFileData = (file, dataUri) => ({
  name: file.name,
  file: dataUri,
  data: file.result,
  size: file.size,
  type: file.type,
  fileId: '',
  progress: 0,
});

export const mapDroppedFiles = (acceptedFiles, prefix, progress = null) => acceptedFiles.map(
  (file) => ({
    name: file.name,
    size: file.size,
    type: file.type,
    fileId: `${prefix}-${Date.now()}-${Math.random()}`,
    progress,
  })
);

export const appendDroppedDocs = (existingDocs, acceptedFiles, prefix) => {
  if (!Array.isArray(acceptedFiles) || acceptedFiles.length === 0) {
    return existingDocs;
  }
  return [
    ...existingDocs,
    ...mapDroppedFiles(acceptedFiles, prefix),
  ];
};

export const removeDocByIndex = (docs, targetIndex) => docs
  .filter((doc, index) => index !== targetIndex);

export const removeDocByFileId = (docs, fileId) => docs.filter((doc) => doc.fileId !== fileId);
